import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {LoginComponent} from './pages/login/login.component';
import {AppLayoutComponent} from './app-layout/components/app-layout.component';
import {AuthGuard} from './infrastructure/auth/auth.guard';
import { DesignTestsComponent } from './pages/design-tests/design-tests.component';
import {ContactWindowComponent} from './pages/contact/contact-window/contact-window.component';
import {PlanComponent} from './pages/plan/plan.component';
import { ForgotPasswordComponent } from './pages/forgot-password/forgot-password.component';
import { ForgotPasswordResetComponent } from './pages/forgot-password-reset/forgot-password-reset.component';
import { CreateNewAccountComponent } from './pages/create-new-account/create-new-account.component';
import { EmailPreferencesComponent } from './pages/email-preferences/email-preferences.component';
import { FeatureFlagGuard } from './infrastructure/auth/feature-flag.guard';
import { FEATURE_FLAG_KEYS } from './infrastructure/domain/feature-flags';

const routes: Routes = [
  {
    path: 'email-preferences/:token',
    component: EmailPreferencesComponent
  },
  {
    path: 'plan',
    component: PlanComponent,
    canActivate: [AuthGuard, FeatureFlagGuard],
    canMatch: [FeatureFlagGuard],
    data: {
      requiredFeatureFlagKey: FEATURE_FLAG_KEYS.BILLING_SUBSCRIPTION_AREA,
      featureFlagFallbackUrl: '/settings',
      featureFlagUnavailableMessage: 'Área de assinatura indisponível no momento.'
    }
  },
  {
    path: 'contact',
    component: ContactWindowComponent,
    //canActivate: [AuthGuard], // TODO: Retirar a necessidade de estar logado para abrir chamados
    loadChildren: () => import('./pages/contact/contact.module').then(m => m.ContactModule),
  },
  {
    path: 'support',
    component: ContactWindowComponent,
    //canActivate: [AuthGuard], // TODO: Retirar a necessidade de estar logado para abrir chamados
    loadChildren: () => import('./pages/contact/contact.module').then(m => m.ContactModule),
  },
  {
    path: 'design-tests/quill2',
    loadComponent: () => import('../spikes/001-quill2-ckeditor/rich-text.component').then(m => m.RichTextComponent)
  },
  {
    path: 'design-tests',
    pathMatch: 'full',
    component: DesignTestsComponent
  },
  {
    path: '',
    component: AppLayoutComponent,
    canActivate: [AuthGuard],
    loadChildren: () => import('./app-layout/app-layout.module').then(m => m.AppLayoutModule),
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true, anchorScrolling: 'enabled' })],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
